module.exports = __webpack_public_path__ + "static/media/sinofy.561c0be4.png";